<div [className]="!renderConfirm ? 'flex justify-center h-full' : 'hidden'">
  <div class="flex flex-col justify-center w-full sm:w-3/4">
    <h2 class="text-4xl my-2 use-rhetorik-sans">Create Account</h2>
    <div class="flex items-center my-2">
      <div class="text-gray-tricon">Already have an account?</div>
      <button class="mx-2 min-w-0" mat-button color="accent" [routerLink]="['/public/login/redirect', 'true']">SIGN
        IN</button>
    </div>
    <div class="text-gray-tricon">All fields required</div>
    <form id="registerForm" #registerForm="ngForm" (ngSubmit)="onSubmit()" class="flex flex-col justify-center mt-2">
      <div class="grid grid-cols-1 gap-0 sm:grid-cols-2 sm:gap-8">
        <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
          <mat-label>First Name</mat-label>
          <input matInput type="text" name="FirstName" id="FirstName" required [(ngModel)]="model.FirstName"
            #FirstName="ngModel">
          <mat-error>
            Please fill out this field
          </mat-error>
        </mat-form-field>

        <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
          <mat-label>Last Name</mat-label>
          <input matInput type="text" name="LastName" id="LastName" required [(ngModel)]="model.LastName"
            #LastName="ngModel">
          <mat-error>
            Please fill out this field
          </mat-error>
        </mat-form-field>
      </div>


      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Phone Number</mat-label>
        <mat-input-tel name="PhoneNumber" id="PhoneNumber" required [(ngModel)]="phoneNumber" #PhoneNumber="ngModel">
        </mat-input-tel>
        <mat-error>
          Please fill out this field. Format: (123) 456-7889
        </mat-error>
      </mat-form-field>

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Email Address</mat-label>
        <input matInput type="text" name="Email" id="Email" required email [(ngModel)]="model.Email" #Email="ngModel">
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Password</mat-label>
        <input matInput minlength="8" [type]="hide ? 'password' : 'text'" name="Password" id="Password" required
          [(ngModel)]="model.Password" #Password="ngModel">
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide">
          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error>
          Please fill out this field.
        </mat-error>
        <mat-hint class="text-gray-tricon">Must include at least eight characters including numbers, special characters,
          uppercase
          letters, and lowercase letters.</mat-hint>
      </mat-form-field>

      <div class="flex justify-start my-5">
        <mat-checkbox class="mr-2" name="AgreedToTerms" id="AgreedToTerms" [(ngModel)]="model.AgreedToTerms"
          #AgreedToTerms binary="true" required>
        </mat-checkbox>
        <div class="ml-2 text-gray-tricon">
          By providing your contact information above and checking this box, you consent to receive periodic
          calls, emails, or text/SMS messages from Tricon for any purpose, including marketing,
          and you consent to our
          <a class="underline" target="_blank" rel="noopener noreferrer" href="{{ termsOfAgreementUrl }}">Terms of Agreement</a>
          and
          <a class="underline" target="_blank" rel="noopener noreferrer" href="https://www.{{triconDomain}}.com/privacy-policy/">Privacy Policy</a>
          . Message and data rates apply. Consent is not a condition of purchase.
        </div>
      </div>

      <button mat-flat-button color="primary" type="submit" class="my-3" [disabled]="!registerForm.form.valid">CREATE
        ACCOUNT</button>
    </form>
  </div>
</div>
<div *ngIf="renderConfirm" class="h-full">
  <router-outlet></router-outlet>
</div>
